import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "pp-draw-results-button",
  "data-accordion": ""
}
const _hoisted_2 = ["id", "aria-controls"]

import DsIcon from "@sazka/design-system/src/icon/ds-icon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'pp-draw-numbers-accordion',
  props: {
    tableTitle: {},
    ariaControls: {},
    id: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "pp-draw-results-button__collapsible-btn pp-draw-results-button__collapsible-btn--inset",
      id: _ctx.id,
      "aria-controls": _ctx.ariaControls
    }, [
      _createTextVNode(_toDisplayString(_ctx.tableTitle) + " ", 1),
      _createVNode(DsIcon, {
        name: "arrow-down-thin",
        width: 16,
        height: 16
      })
    ], 8, _hoisted_2),
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})